import { render, staticRenderFns } from "./Verify_actlist.vue?vue&type=template&id=24436918"
import script from "./Verify_actlist.vue?vue&type=script&lang=js"
export * from "./Verify_actlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports